module.exports = __webpack_public_path__ + "static/assets/f4dc047080ceaf573618136674be653a.png";